import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  getCustomers,
  createBulkItemSale,
  getItems,
  getInvoiceNumber,
  postGeneralData,
  getUnits,
  getItemSales,
  createItemSalesReturn,
  getItemSalesReturns,
} from '../../../Utility/Api';
import { WarehouseContext } from "../../../Utility/UserContext";
import { getFormattedCurrentDate2, NaviGate, onReqCreatePayment, shop_id, warehouse_id } from "../../../Utility/function";
import CustomerAddModal from '../../Common/CustomerAddModal';
import ItemSalesInvoiceModal from './ItemSalesInvoiceModal';

const ItemSales = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, UserItem, shopItem, selectedWarehouse } = useContext(WarehouseContext);

  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [unqui, setunqui] = useState("");
  const [searchCustomerTerm, setSearchCustomerTerm] = useState("");
  const [CustomerId, setCustomerId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [isCustomerFocused, setIsCustomerFocused] = useState(false);
  const [showCustomer, setShowCustomer] = useState(false);

  // Payment states
  const [paymentType, setPaymentType] = useState("1"); // "1" = Cash, "4" = Card, "3" = UPI, "2" = Credit, "5" = Mix
  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");

  // Over-discount states
  const [Overdiscount, setOverdiscount] = useState(0);
  const [OverdiscountType, setOverdiscountType] = useState("%");

  // Return Modal states
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnSearchText, setReturnSearchText] = useState("");
  const [pastOrders, setPastOrders] = useState([]);
  const [returnOrder, setReturnOrder] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnQtys, setReturnQtys] = useState({});
  const [returnReason, setReturnReason] = useState("");
  const [returnRefundType, setReturnRefundType] = useState("bank");
  const [returnInvoiceNo, setReturnInvoiceNo] = useState("");
  const [globalReturns, setGlobalReturns] = useState([]);
  const [isSearchingOrders, setIsSearchingOrders] = useState(false);
  const [ReturnItem, setReturnItem] = useState([]);

  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [lastSaleData, setLastSaleData] = useState(null);

  const [showHeldSalesModal, setShowHeldSalesModal] = useState(false);
  const [heldSales, setHeldSales] = useState(() => {
    const saved = localStorage.getItem("ztr_held_sales");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("ztr_held_sales", JSON.stringify(heldSales));
  }, [heldSales]);

  // Real-time Clock
  const [currentTime, setCurrentTime] = useState("");
  useEffect(() => {
    const updateTime = () => {
      const d = new Date();
      setCurrentTime(d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" }));
    };
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    fetchCustomers();
    fetchProducts();
    fetchUnitsList();
    fetchInvoiceNumber();
  }, []);

  const fetchInvoiceNumber = async () => {
    try {
      const response = await getInvoiceNumber(7, shopItem?.shop_id || shop_id);
      if (response.data && response.data.invoice_no) {
        setunqui(response.data.invoice_no);
      }
    } catch (error) {
      console.error('Error fetching Invoice Number:', error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await getItems();
      if (response.data && response.data.data) {
        const mapped = response.data.data.map(item => ({
          ...item,
          product_id: item.id,
          product_name: item.item_name,
          p_price: parseFloat(item.sales_price || 0),
          sell_price: parseFloat(item.sales_price || 0),
          qty: 1,
          total: parseFloat(item.sales_price || 0),
          offer_type: ""
        }));
        setProducts(mapped);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const fetchUnitsList = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnitsList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  const getUnitTitle = (product) => {
    if (!product || !product.units) return "";
    const matchedUnit = unitsList.find(u => String(u.id) === String(product.units));
    return matchedUnit?.title ? ` ${matchedUnit.title}` : "";
  };

  const isLitreProduct = (product) => {
    if (!product || !product.units) return false;
    const matchedUnit = unitsList.find(u => String(u.id) === String(product.units));
    if (!matchedUnit || !matchedUnit.title) return false;
    const title = matchedUnit.title.toLowerCase().trim();
    return title === "li" || title === "litre" || title === "litres" || title === "liter" || title === "liters";
  };

  const filteredCustomers = searchCustomerTerm
    ? customers.filter(item =>
        item.status !== 1 && item.name.toLowerCase().includes(searchCustomerTerm.toLowerCase())
      )
    : customers.filter(item => item.status !== 1);

  const filteredProducts = searchTerm.length === 0
    ? products
    : products.filter(product =>
        product.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.item_code?.toLowerCase().includes(searchTerm.toLowerCase())
      );

  const handleAddProduct = (product) => {
    const isDuplicate = selectedProducts.some(p => p.product_id === product.product_id);
    if (isDuplicate) {
      toast.info("Product already added to list");
      return;
    }
    const isLitre = isLitreProduct(product);
    const initialQty = 1;
    const sellPrice = isLitre 
      ? parseFloat(product.sell_price || 0) / 1000.0 
      : parseFloat(product.sell_price || 0);
    const total = initialQty * sellPrice;

    const updated = [...selectedProducts, { 
      ...product, 
      sell_price: sellPrice, 
      qty: initialQty, 
      total: total, 
      discount_type: "%",
      discount_value: 0,
      offer_type: "" 
    }];
    setSelectedProducts(updated);
    setSearchTerm("");
    setIsFocused(false);
  };

  const handleRemoveProduct = (index) => {
    const updated = selectedProducts.filter((_, i) => i !== index);
    setSelectedProducts(updated);
  };

  const handleProductChange = (index, name, value) => {
    const updated = [...selectedProducts];
    const item = { ...updated[index], [name]: value };

    const qty = parseFloat(item.qty || 0);
    const sellPrice = parseFloat(item.sell_price || 0);
    const discType = item.discount_type || "%";
    const discVal = parseFloat(item.discount_value || 0);

    const baseTotal = qty * sellPrice;
    let discountAmount = 0;

    if (discType === "%") {
      discountAmount = (baseTotal * discVal) / 100.0;
    } else if (discType === "INR" || discType === "₹") {
      discountAmount = discVal;
    }

    item.total = Math.max(0, baseTotal - discountAmount);

    updated[index] = item;
    setSelectedProducts(updated);
  };

  const handleQtyStep = (index, step) => {
    const item = selectedProducts[index];
    const currentQty = parseFloat(item.qty || 0);
    const newQty = Math.max(1, currentQty + step);
    handleProductChange(index, "qty", newQty);
  };

  // Financial calculations
  const subTotal = selectedProducts.reduce((sum, p) => sum + (parseFloat(p.total) || 0), 0);
  const itemDiscountsTotal = selectedProducts.reduce((sum, p) => sum + (parseFloat(p.discount_amount) || 0), 0);
  const overDiscountAmount = OverdiscountType === "%"
    ? (subTotal * Overdiscount / 100)
    : Overdiscount;
  const returnTotal = ReturnItem.reduce((acc, item) => acc + Number(item?.returnAmount || 0), 0);
  const amountDue2 = Math.max(0, subTotal - overDiscountAmount - returnTotal);

  const handleReset = () => {
    setSelectedProducts([]);
    setSearchCustomerTerm("");
    setCustomerId("");
    setOverdiscount(0);
    setOverdiscountType("%");
    setPaymentType("1");
    setCashAmount("");
    setCardAmount("");
    setReturnItem([]);
    fetchInvoiceNumber();
  };

  const handleHoldSale = () => {
    if (selectedProducts.length === 0) {
      toast.error("Cannot hold an empty sale");
      return;
    }

    const holdId = `HOLD-${Date.now()}`;
    const newHold = {
      id: holdId,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      customerName: searchCustomerTerm || "Walk-in Customer",
      customerId: CustomerId,
      products: selectedProducts,
      overDiscount: Overdiscount,
      overDiscountType: OverdiscountType,
      returnItem: ReturnItem,
      totalAmount: amountDue2
    };

    setHeldSales(prev => [...prev, newHold]);
    toast.success("Sale placed on hold successfully");
    handleReset();
  };

  const handleResumeSale = (holdItem) => {
    setCustomerId(holdItem.customerId || "");
    setSearchCustomerTerm(holdItem.customerName || "");
    setSelectedProducts(holdItem.products || []);
    setOverdiscount(holdItem.overDiscount || 0);
    setOverdiscountType(holdItem.overDiscountType || "%");
    setReturnItem(holdItem.returnItem || []);
    
    setHeldSales(prev => prev.filter(h => h.id !== holdItem.id));
    setShowHeldSalesModal(false);
    toast.success("Held sale resumed successfully");
  };

  const handleDeleteHeldSale = (id, e) => {
    e.stopPropagation();
    setHeldSales(prev => prev.filter(h => h.id !== id));
    toast.success("Held sale deleted");
  };

  const handleOpenReturnModal = async () => {
    try {
      showLoader();
      setReturnSearchText("");
      setPastOrders([]);
      setReturnOrder(null);
      setReturnItems([]);
      setReturnQtys({});
      setReturnReason("");
      setReturnRefundType("bank");

      const res = await getItemSalesReturns().catch(() => ({ data: { data: [] } }));
      setGlobalReturns(res.data?.data || []);

      setShowReturnModal(true);
    } catch (e) {
      console.error(e);
      toast.error("Failed to load return data");
    } finally {
      hideLoader();
    }
  };

  const fetchPastOrders = async (query = "") => {
    try {
      setIsSearchingOrders(true);
      const shopId = shopItem?.shop_id || shop_id;
      const response = await getItemSales(1, query, shopId);
      if (response.data && response.data.data) {
        setPastOrders(response.data.data);
      } else {
        setPastOrders([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSearchingOrders(false);
    }
  };

  useEffect(() => {
    if (showReturnModal) {
      fetchPastOrders(returnSearchText);
    }
  }, [returnSearchText, showReturnModal]);

  const handleSelectReturnOrder = async (order) => {
    try {
      showLoader();
      setReturnOrder(order);
      setReturnItems(order.details || []);
      setReturnQtys({});

      const invRes = await getInvoiceNumber(4);
      if (invRes.data?.invoice_no) {
        setReturnInvoiceNo(invRes.data.invoice_no);
      } else {
        const shopId = shopItem?.shop_id || shopItem?.id || "1";
        setReturnInvoiceNo(`RN${new Date().getFullYear()}-SH${shopId}-0001`);
      }
    } catch (e) {
      console.error(e);
      setReturnInvoiceNo(`RN${new Date().getFullYear()}-SH1-0001`);
    } finally {
      hideLoader();
    }
  };

  const getUnitPrice = (item) => {
    const qty = parseFloat(item.qty || 1);
    const pPrice = parseFloat(item.p_price || 0);
    return qty > 0 ? pPrice / qty : 0;
  };

  const getAlreadyReturnedQty = (detailId) => {
    let count = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        retData = JSON.parse(ret.return_data || "[]");
      } catch (e) {}
      if (Array.isArray(retData)) {
        retData.forEach((item) => {
          if (String(item.id) === String(detailId)) {
            count += parseFloat(item.returnqty || 0);
          }
        });
      }
    });
    return count;
  };

  const handleReturnQtyChange = (detailId, val, maxVal) => {
    let num = parseFloat(val) || 0;
    if (num < 0) num = 0;
    if (num > maxVal) num = maxVal;
    setReturnQtys((prev) => ({ ...prev, [detailId]: num }));
  };

  const calcReturnFinancials = () => {
    let totalReturn = 0;
    returnItems.forEach((it) => {
      const qty = returnQtys[it.id] || 0;
      const unitPrice = getUnitPrice(it);
      totalReturn += qty * unitPrice;
    });

    const returnedAmt = getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id);
    const creditBalance = Math.max(0, parseFloat(returnOrder?.remaining || 0) - returnedAmt);

    const creditAdjust = Math.min(totalReturn, creditBalance);
    const refundAmount = Math.max(0, totalReturn - creditAdjust);
    const newCredit = Math.max(0, creditBalance - creditAdjust);
    return { totalReturn, creditAdjust, refundAmount, newCredit };
  };

  const getOrderReturnedAmount = (orderId, orderMasterId) => {
    let totalReturned = 0;
    globalReturns.forEach((ret) => {
      let retData = [];
      try {
        retData = JSON.parse(ret.return_data || "[]");
      } catch (e) {}

      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.om_id == orderMasterId ||
            retItem.unique_id === orderId ||
            (ret.unique_id && ret.unique_id.includes(orderId));

          if (isMatch) {
            totalReturned += parseFloat(retItem.amount || 0);
          }
        });
      }
    });
    return totalReturned;
  };

  const handleSubmitReturn = () => {
    const selectedItems = returnItems.filter((it) => (returnQtys[it.id] || 0) > 0);
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to return");
      return;
    }

    const fin = calcReturnFinancials();
    const shopId = shopItem?.shop_id || shopItem?.id || "1";

    const newReturns = selectedItems.map((it) => {
      const qty = returnQtys[it.id];
      const unitPrice = getUnitPrice(it);
      return {
        id: it.id,
        om_id: it.om_id,
        item_id: it.item_id,
        product_name: it.product_title || `Item #${it.item_id}`,
        returnQty: qty,
        returnAmount: qty * unitPrice,
        unique_id: returnOrder?.order_id,
      };
    });

    setReturnItem((prev) => {
      const filteredPrev = prev.filter(p => !newReturns.some(n => n.id === p.id));
      return [...filteredPrev, ...newReturns];
    });

    toast.success("Items added to Return list successfully!");
    setShowReturnModal(false);
  };

  const handlePaymentOptionClick = (type) => {
    setPaymentType(type);
    setCashAmount("");
    setCardAmount("");
  };

  const handlePayClick = () => {
    if (selectedProducts.length === 0) {
      toast.error("Please add at least one item to pay");
      return;
    }

    if (paymentType === "2" && !CustomerId) {
      toast.error("Customer details are required for credit sales.");
      return;
    }

    if (paymentType === "5") {
      const cashVal = parseFloat(cashAmount || 0);
      const cardVal = parseFloat(cardAmount || 0);
      if (cashVal + cardVal <= 0) {
        toast.error("Please enter mix payment split details");
        return;
      }
    }

    handleSubmit(paymentType);
  };

  const handleSubmit = async (type = "1") => {
    const grandTotal = amountDue2;
    let paidAmount = grandTotal;
    let pendingAmount = 0;
    let purchase_type = "1"; // Default Cash Sale

    let paydata = {
      orderID: unqui,
      date: getFormattedCurrentDate2(),
      amount: "0",
      total_amount: grandTotal.toFixed(3),
      cash: 0,
      credit: 0,
      card: 0,
      type: 2, // Sales
      mop: "0",
      complete: "0",
    };

    if (type === "1") {
      // Cash
      paydata.cash = grandTotal;
      paydata.mop = "1";
      paydata.complete = "1";
      purchase_type = "1";
      paidAmount = grandTotal;
      pendingAmount = 0;
    } else if (type === "4") {
      // Card
      paydata.card = grandTotal;
      paydata.mop = "4";
      paydata.complete = "1";
      purchase_type = "1";
      paidAmount = grandTotal;
      pendingAmount = 0;
    } else if (type === "3") {
      // UPI
      paydata.upi = grandTotal;
      paydata.mop = "3";
      paydata.complete = "1";
      purchase_type = "1";
      paidAmount = grandTotal;
      pendingAmount = 0;
    } else if (type === "2") {
      // Credit
      paydata.credit = grandTotal;
      paydata.mop = "2";
      paydata.complete = "0";
      purchase_type = "2";
      paidAmount = 0;
      pendingAmount = grandTotal;
    } else if (type === "5") {
      // Mix split
      const cashVal = parseFloat(cashAmount || 0);
      const cardVal = parseFloat(cardAmount || 0);
      const totalPaid = cashVal + cardVal;
      const rem = grandTotal - totalPaid;

      if (rem > 0) {
        Object.assign(paydata, { cash: cashVal, card: cardVal, credit: rem, mop: "1,4,2", complete: "0" });
        purchase_type = "2";
        paidAmount = totalPaid;
        pendingAmount = rem;
      } else {
        Object.assign(paydata, { cash: cashVal, card: cardVal, mop: "1,4", complete: "1" });
        purchase_type = "1";
        paidAmount = grandTotal;
        pendingAmount = 0;
      }
    }

    showLoader();
    try {
      const formattedItems = selectedProducts.map(item => ({
        p_id: Number(item.product_id),
        qty: Number(item.qty),
        price: Number(item.sell_price),
        total: Number(item.total || 0),
        remarks: item.offer_type === "free" ? "Free product" : "Normal sale",
        is_free: item.offer_type === "free" ? "1" : "0",
      }));

      let payload = {
        total: {
          withoutTax: subTotal.toFixed(3),
          priceTotal: subTotal.toFixed(3),
        },
        products: formattedItems,
        customer_id: CustomerId,
        user_id: UserItem?.user_id || "",
        warehouse_id: selectedWarehouse?.id || warehouse_id,
        unique_id: unqui,
        shop_id: shopItem?.shop_id || "0",
        total_amount: grandTotal.toFixed(3),
        discount: overDiscountAmount.toFixed(3),
        vat: 0,
        purchase_unit: purchase_type,
        amount: paidAmount.toFixed(3),
        sales_remaining: pendingAmount.toFixed(3),
      };

      const response = await createBulkItemSale(payload);
      if (response.data && response.data.status === "success") {
        // Use the real ORD-XXXXXXXX order_id returned by backend, not the invoice number
        paydata.orderID = response.data.order_id || unqui;
        await onReqCreatePayment(paydata);

        // Submit return items if any exist
        if (ReturnItem.length > 0) {
          try {
            const returnPayloads = ReturnItem.map((it) => {
              return {
                id: it.id,
                om_id: it.om_id,
                p_id: it.item_id,
                product_name: it.product_name,
                returnqty: it.returnQty,
                amount: parseFloat(it.returnAmount).toFixed(2),
              };
            });

            const shopId = shopItem?.shop_id || shopItem?.id || "1";
            
            let returnInvoiceNoVal = "";
            try {
              const invRes = await getInvoiceNumber(4);
              returnInvoiceNoVal = invRes.data?.invoice_no;
            } catch (e) {}
            if (!returnInvoiceNoVal) {
              returnInvoiceNoVal = `RN${new Date().getFullYear()}-SH${shopId}-0001`;
            }

            await createItemSalesReturn({
              unique_id: ReturnItem[0]?.unique_id,
              return_invoice_no: returnInvoiceNoVal,
              amount: returnTotal.toFixed(2),
              credit_adjustment: returnTotal.toFixed(2),
              refund_amount: "0.00",
              status: "0",
              shop_id: shopId,
              user_id: UserItem?.user_id || "",
              return_data: JSON.stringify(returnPayloads),
            });
          } catch (retError) {
            console.error("Return submit failed:", retError);
            toast.error("Warning: Sale succeeded, but return registration failed.");
          }
        }

        try {
          const generalDataPayload = {
            type: "3",
            ref_id: 'INV_' + unqui,
            remarks: "Item POS Sales",
            date: getFormattedCurrentDate2(),
            created_by: UserItem?.user_id,
            shop_id: shopItem?.id || "0",
            amount: grandTotal.toFixed(3),
            is_debit: "0",
          };
          await postGeneralData(generalDataPayload);
        } catch (e) {
          console.error("General ledger log failed:", e);
        }

        toast.success("Item Sales Order created successfully!");

        // Build invoice data and show the modal
        const selectedCustomer = customers.find(c => String(c.customer_id) === String(CustomerId));
        // Resolve unit title for each product from unitsList
        const productsWithUnit = selectedProducts.map(p => ({
          ...p,
          unit_title: (() => {
            if (!p.units) return '';
            const u = unitsList.find(u => String(u.id) === String(p.units));
            return u?.title || '';
          })(),
        }));
        setLastSaleData({
          invoiceNo: unqui,
          orderId: response.data.order_id || unqui,
          date: new Date().toLocaleDateString('en-IN'),
          time: new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
          customerName: searchCustomerTerm || 'Walk-in Customer',
          customerPhone: selectedCustomer?.phone || '',
          products: productsWithUnit,
          subTotal,
          overDiscountAmount,
          amountDue: amountDue2,
          paymentType,
          returnTotal,
        });
        setShowInvoiceModal(true);
      } else {
        toast.error(response.data?.message || "Failed to create order");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error saving sales order");
    } finally {
      hideLoader();
    }
  };

  const handleInvoiceClose = () => {
    setShowInvoiceModal(false);
    setLastSaleData(null);
    handleReset();
  };

  return (
    <>
      <div className="page-wrappers" style={{ height: "calc(100vh - 65px)", overflow: "hidden" }}>
        <div className="page-content d-flex flex-column h-100 p-2" style={{ fontFamily: "Poppins", overflow: "hidden" }}>
          <NaviGate />
          
          {/* Main POS Container Card */}
          <div className="card border-0 shadow-sm rounded-2xl bg-white d-flex flex-column flex-grow-1 overflow-hidden" style={{ border: "1px solid #f1f5f9" }}>
            
            {/* 1. Header Bar */}
            <div className="px-3 py-2 border-bottom flex-shrink-0 bg-white">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 text-start">
                <div>
                  <h6 className="mb-0 fw-bold text-slate-800" style={{ fontSize: "16px" }}>Sales ID: {unqui}</h6>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="text-xs font-semibold text-slate-600 bg-slate-50 px-2.5 py-1 rounded border border-slate-200 d-flex align-items-center gap-1.5">
                    <i className="bi bi-clock text-slate-400"></i>
                    <span>Date & Time: {new Date().toLocaleDateString()} {currentTime}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 2. Compact Single-Row Search Section */}
            <div className="px-3 py-2 border-bottom flex-shrink-0 bg-slate-50 text-start">
              <div className="row g-2 align-items-center">
                
                {/* Col 1: Customer Search */}
                <div className="col-md-5">
                  <div className="input-group input-group-sm">
                    <div className="dropdown flex-fill position-relative">
                      <div className="position-relative">
                        <input
                          type="text"
                          className="form-control form-control-sm ps-4"
                          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, height: "32px", fontSize: "12px" }}
                          placeholder="Search & Select Customer..."
                          value={searchCustomerTerm}
                          onFocus={() => setIsCustomerFocused(true)}
                          onClick={() => setIsCustomerFocused(true)}
                          onBlur={() => setTimeout(() => setIsCustomerFocused(false), 200)}
                          onChange={(e) => {
                            setSearchCustomerTerm(e.target.value);
                            setCustomerId("");
                            setIsCustomerFocused(true);
                          }}
                        />
                        <i className="bi bi-person-search position-absolute text-slate-400" style={{ left: "10px", top: "8px", fontSize: "13px" }}></i>
                      </div>
                      {isCustomerFocused && (
                        <ul
                          className="dropdown-menu show w-100 p-1 shadow-lg position-absolute"
                          style={{ maxHeight: '220px', overflowY: 'auto', zIndex: 1050, top: '100%', left: 0 }}
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          {filteredCustomers.length > 0 ? (
                            filteredCustomers.map(customer => (
                              <li key={customer.customer_id}>
                                <button
                                  type="button"
                                  className="dropdown-item rounded py-1.5 text-start"
                                  onClick={() => {
                                    setCustomerId(customer.customer_id);
                                    setSearchCustomerTerm(customer.name);
                                    setIsCustomerFocused(false);
                                  }}
                                >
                                  <span className="fw-bold text-slate-700 block text-start d-block" style={{ fontSize: '13px' }}>{customer.name}</span>
                                  <small className="text-slate-400 block text-start d-block" style={{ fontSize: '11px' }}>{customer.phone} | {customer.branch}</small>
                                </button>
                              </li>
                            ))
                          ) : (
                            <li className="p-2 text-center text-muted text-sm">No customers found</li>
                          )}
                        </ul>
                      )}
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm px-2.5 d-flex align-items-center justify-content-center"
                      style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: "32px" }}
                      onClick={() => setShowCustomer(true)}
                      title="Add Customer"
                    >
                      <i className="bi bi-plus-lg fs-6"></i>
                    </button>
                  </div>
                </div>

                {/* Col 2: Search Item */}
                <div className="col-md-7 position-relative">
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control form-control-sm ps-4"
                      style={{ height: "32px", fontSize: "12px" }}
                      placeholder="Search | Item Name | Code..."
                      value={searchTerm}
                      onFocus={() => setIsFocused(true)}
                      onClick={() => setIsFocused(true)}
                      onBlur={() => setTimeout(() => setIsFocused(false), 200)}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setIsFocused(true);
                      }}
                    />
                    <i className="bi bi-search position-absolute text-slate-400" style={{ left: "10px", top: "8px", fontSize: "13px" }}></i>
                  </div>
                  {isFocused && filteredProducts.length > 0 && (
                    <div
                      className="position-absolute bg-white border border-secondary rounded shadow-lg w-100 mt-1"
                      style={{ zIndex: 1050, maxHeight: "220px", overflowY: "auto", left: 0 }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      <ul className="list-group list-group-flush text-start mb-0">
                        {filteredProducts.map(product => (
                          <li
                            key={product.product_id}
                            className="list-group-item list-group-item-action p-2 d-flex justify-content-between align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleAddProduct(product)}
                          >
                            <div>
                              <span className="fw-bold text-dark block" style={{ fontSize: "13px" }}>
                                {product.product_name}
                                {product.item_code && <span className="text-muted ms-2" style={{ fontSize: "11px", fontWeight: "normal" }}>({product.item_code})</span>}
                              </span>
                              {product.descriptions && (
                                <small className="text-muted block mt-0.5 d-block" style={{ fontSize: "11px", whiteSpace: "normal" }}>{product.descriptions}</small>
                              )}
                              <small className="text-dark fw-bold block mt-0.5 d-block" style={{ fontSize: "11px" }}>Stock: {product.remaining_qty || 0} {getUnitTitle(product)}</small>
                            </div>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-2.5 py-0.5 fw-bold"
                              style={{ fontSize: '12px' }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAddProduct(product);
                              }}
                            >
                              Add
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

              </div>
            </div>

            {/* 3. Middle Scrollable Cart Table */}
            <div className="flex-grow-1 overflow-auto p-2 bg-slate-50" style={{ minHeight: 0 }}>
              <div className="table-responsive bg-white rounded shadow-sm border h-100">
                <table className="table table-bordered table-hover align-middle text-center mb-0">
                  <thead className="table-light sticky-top" style={{ zIndex: 5 }}>
                    <tr className="text-slate-700" style={{ fontSize: "12px" }}>
                      <th style={{ width: "4%" }}>#</th>
                      <th className="text-start" style={{ width: "26%" }}>Item Name</th>
                      <th style={{ width: "13%" }}>Quantity (mL)</th>
                      <th style={{ width: "11%" }}>Sell Price</th>
                      <th style={{ width: "11%" }}>Offer</th>
                      <th style={{ width: "9%" }}>Dis Type</th>
                      <th style={{ width: "9%" }}>Discount</th>
                      <th style={{ width: "12%" }}>Total Price</th>
                      <th style={{ width: "5%" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProducts.length > 0 ? (
                      selectedProducts.map((product, index) => (
                        <tr key={product.product_id} style={{ fontSize: "13px" }}>
                          <td className="fw-semibold text-slate-500">{index + 1}</td>
                          <td className="text-start fw-semibold text-slate-800" style={{ whiteSpace: "normal" }}>
                            {product.product_name}
                          </td>
                          <td>
                            <div className="d-flex align-items-center gap-1 justify-content-center">
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm px-2 py-0"
                                onClick={() => handleQtyStep(index, -1)}
                              >−</button>
                              <input
                                type="number"
                                className="form-control form-control-sm text-center py-0"
                                style={{ width: "65px", height: "26px", fontSize: "12px" }}
                                value={product.qty}
                                onChange={(e) => handleProductChange(index, "qty", parseFloat(e.target.value || 0))}
                                onWheel={(e) => e.target.blur()}
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm px-2 py-0"
                                onClick={() => handleQtyStep(index, 1)}
                              >+</button>
                            </div>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control form-control-sm text-center py-0"
                              style={{ height: "26px", fontSize: "12px" }}
                              value={product.sell_price}
                              onChange={(e) => handleProductChange(index, "sell_price", parseFloat(e.target.value || 0))}
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm py-0"
                              style={{ minWidth: "85px", height: "26px", fontSize: "12px" }}
                              value={product.offer_type || ""}
                              onChange={(e) => handleProductChange(index, "offer_type", e.target.value)}
                            >
                              <option value="">No Offer</option>
                              <option value="free">Offer</option>
                            </select>
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm text-center py-0"
                              style={{ minWidth: "55px", height: "26px", fontSize: "12px" }}
                              value={product.discount_type || "%"}
                              onChange={(e) => handleProductChange(index, "discount_type", e.target.value)}
                            >
                              <option value="%">%</option>
                              <option value="₹">₹</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="number"
                              className="form-control form-control-sm text-center py-0"
                              style={{ width: "60px", height: "26px", fontSize: "12px" }}
                              value={product.discount_value || 0}
                              onChange={(e) => handleProductChange(index, "discount_value", parseFloat(e.target.value || 0))}
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>
                          <td className="fw-bold text-slate-800">
                            ₹{parseFloat(product.total || 0).toFixed(2)}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-link text-danger p-0 border-0"
                              onClick={() => handleRemoveProduct(index)}
                            >
                              <i className="bi bi-trash fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="border-0" style={{ pointerEvents: "none" }}>
                        <td colSpan="9" className="text-center text-slate-400 py-5 border-0" style={{ border: "none", backgroundColor: "transparent" }}>
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <i className="bi bi-cart3 fs-3 text-slate-300 mb-1"></i>
                            <span className="fw-semibold text-slate-400" style={{ fontSize: "13px" }}>No products selected.</span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Return Items List if present */}
              {ReturnItem.length > 0 && (
                <div className="mt-2 p-2 bg-danger bg-opacity-10 border border-danger border-opacity-20 rounded-xl text-start">
                  <h6 className="fw-bold mb-1 text-danger d-flex align-items-center gap-2" style={{ fontSize: "12px" }}>
                    🔄 Return Items List
                  </h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-sm align-middle text-center mb-0 bg-white">
                      <thead className="table-light">
                        <tr style={{ fontSize: "11px" }}>
                          <th>#</th>
                          <th className="text-start">Item</th>
                          <th>Qty (mL)</th>
                          <th>Amount</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ReturnItem.map((item, index) => (
                          <tr key={`${item.unique_id}-${item.id}`} style={{ fontSize: "12px" }}>
                            <td>{index + 1}</td>
                            <td className="text-start fw-semibold text-slate-700">{item.product_name}</td>
                            <td>{item.returnQty}</td>
                            <td className="fw-bold text-slate-700">₹{parseFloat(item.returnAmount).toFixed(2)}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link text-danger p-0 border-0"
                                onClick={() => {
                                  setReturnItem(prev => prev.filter(ri => ri.id !== item.id));
                                }}
                              >
                                <i className="bi bi-trash fs-6"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            {/* 4. Bottom Panel */}
            <div className="px-3 py-2 bg-white border-top flex-shrink-0 shadow-lg" style={{ borderTop: "2px solid #e2e8f0" }}>
              
              {/* Row 1: Action Buttons Bar */}
              <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                <button
                  type="button"
                  className="btn text-white font-bold px-4 py-1.5 rounded-lg d-flex align-items-center gap-1.5"
                  style={{ backgroundColor: "#8b0000", borderColor: "#8b0000", fontSize: "13px" }}
                  onClick={handleReset}
                >
                  <i className="bi bi-x-lg"></i> Reset
                </button>

                <button
                  type="button"
                  className="btn btn-outline-secondary font-semibold px-3 py-1.5 rounded-lg d-flex align-items-center gap-1.5"
                  style={{ fontSize: "13px" }}
                  onClick={handleHoldSale}
                  disabled={selectedProducts.length === 0}
                >
                  <i className="bi bi-pause-circle"></i> Hold Sale
                </button>

                <button
                  type="button"
                  className="btn btn-dark font-semibold px-3 py-1.5 rounded-lg d-flex align-items-center gap-1.5 ms-auto"
                  style={{ fontSize: "13px", backgroundColor: "#1e293b" }}
                  onClick={handleOpenReturnModal}
                >
                  <i className="bi bi-arrow-counterclockwise"></i> Return Items
                </button>
              </div>

              {/* Row 2: Financial Summary (Col 1 & Col 2) + Payment Controls (Col 3) */}
              <div className="row g-3 align-items-center text-start">
                
                {/* Column 1: Subtotal */}
                <div className="col-md-3 border-end pe-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="text-slate-500 font-semibold" style={{ fontSize: "14px" }}>Subtotal</span>
                    <strong className="text-slate-800" style={{ fontSize: "16px" }}>₹{subTotal.toFixed(2)}</strong>
                  </div>
                </div>

                {/* Column 2: Return, Overall-Discounts, Amount Due */}
                <div className="col-md-4 border-end px-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="text-slate-500 font-semibold" style={{ fontSize: "13px" }}>Return</span>
                    <strong className="text-emerald-600" style={{ fontSize: "14px", color: "#10b981" }}>₹{returnTotal.toFixed(2)}</strong>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="text-slate-500 font-semibold" style={{ fontSize: "13px" }}>Overall-Discounts</span>
                    <div className="d-flex align-items-center gap-1">
                      <input
                        type="number"
                        className="form-control form-control-sm text-end py-0"
                        style={{ width: "60px", height: "26px", fontSize: "12px" }}
                        value={Overdiscount}
                        onChange={(e) => setOverdiscount(Math.max(0, parseFloat(e.target.value || 0)))}
                        onWheel={(e) => e.target.blur()}
                      />
                      <select
                        className="form-select form-select-sm py-0 px-1"
                        style={{ width: "50px", height: "26px", fontSize: "11px" }}
                        value={OverdiscountType}
                        onChange={(e) => setOverdiscountType(e.target.value)}
                      >
                        <option value="%">%</option>
                        <option value="INR">₹</option>
                      </select>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center pt-1 border-top">
                    <span className="text-slate-700 font-bold" style={{ fontSize: "14px" }}>Amount Due</span>
                    <strong className="fw-extrabold" style={{ fontSize: "18px", color: "#10b981" }}>₹{amountDue2.toFixed(2)}</strong>
                  </div>
                </div>

                {/* Column 3: Payment Modes & Pay Button */}
                <div className="col-md-5 ps-3 text-end">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="text-xs fw-semibold text-slate-500">Payment:</span>
                    <div className="d-flex gap-1">
                      <button
                        type="button"
                        className={`btn btn-sm d-flex align-items-center justify-content-center p-1.5 rounded ${paymentType === "1" ? "btn-primary text-white shadow-sm" : "btn-outline-secondary"}`}
                        onClick={() => handlePaymentOptionClick("1")}
                        title="Cash"
                        style={{ width: "34px", height: "34px", border: "1px solid #cbd5e1" }}
                      >
                        <i className="bi bi-cash fs-6"></i>
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm d-flex align-items-center justify-content-center p-1.5 rounded ${paymentType === "4" ? "btn-primary text-white shadow-sm" : "btn-outline-secondary"}`}
                        onClick={() => handlePaymentOptionClick("4")}
                        title="Card"
                        style={{ width: "34px", height: "34px", border: "1px solid #cbd5e1" }}
                      >
                        <i className="bi bi-credit-card fs-6"></i>
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm d-flex align-items-center justify-content-center p-1.5 rounded ${paymentType === "3" ? "btn-primary text-white shadow-sm" : "btn-outline-secondary"}`}
                        onClick={() => handlePaymentOptionClick("3")}
                        title="UPI"
                        style={{ width: "34px", height: "34px", border: "1px solid #cbd5e1" }}
                      >
                        <i className="bi bi-qr-code-scan fs-6"></i>
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm d-flex align-items-center justify-content-center p-1.5 rounded ${paymentType === "2" ? "btn-primary text-white shadow-sm" : "btn-outline-secondary"}`}
                        onClick={() => handlePaymentOptionClick("2")}
                        title="Credit"
                        style={{ width: "34px", height: "34px", border: "1px solid #cbd5e1" }}
                      >
                        <i className="bi bi-wallet2 fs-6"></i>
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm d-flex align-items-center justify-content-center px-2.5 rounded font-bold text-xs ${paymentType === "5" ? "btn-primary text-white shadow-sm" : "btn-outline-secondary"}`}
                        onClick={() => handlePaymentOptionClick("5")}
                        style={{ height: "34px", border: "1px solid #cbd5e1" }}
                      >
                        Mix
                      </button>
                    </div>
                  </div>

                  {paymentType === "5" && (
                    <div className="mb-2 text-start p-1.5 rounded-lg border border-slate-200 bg-slate-50 animate__animated animate__fadeIn">
                      <div className="row g-1">
                        <div className="col-6">
                          <label className="text-xs font-bold text-slate-500 mb-0 d-block" style={{ fontSize: "10px" }}>Cash Amount</label>
                          <input
                            type="number"
                            className="form-control form-control-sm py-0"
                            style={{ height: "24px", fontSize: "11px" }}
                            placeholder="0.00"
                            value={cashAmount}
                            onChange={(e) => setCashAmount(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                        <div className="col-6">
                          <label className="text-xs font-bold text-slate-500 mb-0 d-block" style={{ fontSize: "10px" }}>Card Amount</label>
                          <input
                            type="number"
                            className="form-control form-control-sm py-0"
                            style={{ height: "24px", fontSize: "11px" }}
                            placeholder="0.00"
                            value={cardAmount}
                            onChange={(e) => setCardAmount(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Big Emerald Green Pay Button */}
                  <button
                    type="button"
                    className="btn btn-success w-100 py-2 fs-6 fw-bold shadow-sm rounded-lg d-flex align-items-center justify-content-center gap-1.5"
                    style={{ minHeight: "38px", backgroundColor: "#10b981", borderColor: "#10b981" }}
                    onClick={handlePayClick}
                    disabled={selectedProducts.length === 0}
                  >
                    <i className="bi bi-check-all fs-5"></i> Pay
                  </button>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

      <CustomerAddModal
        showCustomer={showCustomer}
        setShowCustomer={setShowCustomer}
        onReqCustomer={fetchCustomers}
      />

      {showInvoiceModal && lastSaleData && (
        <ItemSalesInvoiceModal
          invoiceData={lastSaleData}
          onClose={handleInvoiceClose}
        />
      )}

      {showReturnModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(15, 23, 42, 0.4)", backdropFilter: "blur(8px)", zIndex: 1060 }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "20px", overflow: "hidden" }}>
              
              {/* Header */}
              <div className="modal-header px-4 py-3 border-0" style={{ background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" }}>
                <div>
                  <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2">
                    🔄 Return Items
                  </h5>
                  {returnOrder && (
                    <small className="text-slate-300">
                      Order: {returnOrder.order_id} &nbsp;|&nbsp; Customer: {returnOrder.customer_name || "Walk-in Customer"}
                    </small>
                  )}
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowReturnModal(false)}
                />
              </div>

              {/* Body */}
              <div className="modal-body p-4" style={{ minHeight: "350px" }}>
                {!returnOrder ? (
                  /* 1. Search Order Section */
                  <div className="text-start">
                    <h6 className="fw-bold mb-3 text-slate-700">Search Past Sales Order</h6>
                    <div className="position-relative mb-4">
                      <input
                        type="text"
                        className="form-control ps-5"
                        placeholder="Search by Order ID / Invoice Number / Customer Name..."
                        value={returnSearchText}
                        onChange={(e) => setReturnSearchText(e.target.value)}
                        style={{ borderRadius: "10px" }}
                      />
                      <i className="bi bi-search position-absolute text-slate-400" style={{ left: "15px", top: "12px", fontSize: "16px" }}></i>
                      {isSearchingOrders && (
                        <div className="spinner-border spinner-border-sm text-primary position-absolute" style={{ right: "15px", top: "12px" }} role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </div>

                    <div className="table-responsive" style={{ maxHeight: "300px" }}>
                      <table className="table table-hover align-middle text-center mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>Order ID</th>
                            <th>Customer</th>
                            <th>Date</th>
                            <th>Total Price</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pastOrders.length > 0 ? (
                            pastOrders.map((order) => (
                              <tr
                                key={order.id}
                                onClick={() => handleSelectReturnOrder(order)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="fw-semibold text-slate-700">{order.order_id}</td>
                                <td>{order.customer_name || "Walk-in Customer"}</td>
                                <td>{new Date(order.create_date).toLocaleDateString()}</td>
                                <td>₹{parseFloat(order.overall_price || 0).toFixed(2)}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm px-3 rounded-lg fw-bold"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectReturnOrder(order);
                                    }}
                                  >
                                    Select
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center py-4 text-slate-400">
                                {returnSearchText ? "No matching orders found" : "Search to list past sales orders"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  /* 2. Select Items to Return Section */
                  (() => {
                    const fin = calcReturnFinancials();
                    return (
                      <div className="text-start">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="fw-bold mb-0 text-slate-700">Select Items to Return</h6>
                          <button
                            type="button"
                            className="btn btn-link text-primary p-0 text-decoration-none fw-semibold"
                            onClick={() => setReturnOrder(null)}
                          >
                            ← Back to Search
                          </button>
                        </div>

                        {returnItems.length === 0 ? (
                          <div className="text-center text-muted py-4">No items found for this order.</div>
                        ) : (
                          <div className="table-responsive mb-4">
                            <table className="table table-bordered table-sm align-middle text-center">
                              <thead className="table-light">
                                <tr>
                                  <th>#</th>
                                  <th className="text-start">Item</th>
                                  <th>Sold Qty</th>
                                  <th className="text-danger">Returned Qty</th>
                                  <th>Unit Price</th>
                                  <th style={{ width: "160px" }}>Return Qty</th>
                                  <th className="text-end">Return Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {returnItems.map((it, idx) => {
                                  const alreadyRet = getAlreadyReturnedQty(it.id);
                                  const soldQty = parseFloat(it.qty || 0) + alreadyRet;
                                  const remainingQty = parseFloat(it.qty || 0);
                                  const retQty = returnQtys[it.id] || 0;
                                  const unitPrice = getUnitPrice(it);
                                  const retAmt = retQty * unitPrice;

                                  return (
                                    <tr key={it.id} className={retQty > 0 ? "table-danger" : ""}>
                                      <td>{idx + 1}</td>
                                      <td className="text-start fw-semibold text-slate-700">
                                        {it.product_title || `Item #${it.item_id}`}
                                      </td>
                                      <td>{soldQty}</td>
                                      <td className="text-danger fw-semibold">{alreadyRet > 0 ? alreadyRet : "—"}</td>
                                      <td>₹{unitPrice.toFixed(2)}</td>
                                      <td>
                                        {remainingQty <= 0 ? (
                                          <span className="badge bg-danger">Fully Returned</span>
                                        ) : (
                                          <div className="d-flex align-items-center gap-1 justify-content-center">
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary btn-sm px-2 py-0"
                                              onClick={() => handleReturnQtyChange(it.id, (retQty - 1).toString(), remainingQty)}
                                            >
                                              −
                                            </button>
                                            <input
                                              type="number"
                                              className="form-control form-control-sm qty-input-no-spin text-center"
                                              style={{ width: "80px" }}
                                              value={retQty}
                                              min={0}
                                              max={remainingQty}
                                              onChange={(e) => handleReturnQtyChange(it.id, e.target.value, remainingQty)}
                                              onWheel={(e) => e.target.blur()}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-outline-secondary btn-sm px-2 py-0"
                                              onClick={() => handleReturnQtyChange(it.id, (retQty + 1).toString(), remainingQty)}
                                            >
                                              +
                                            </button>
                                          </div>
                                        )}
                                      </td>
                                      <td className="text-end fw-semibold text-slate-700">
                                        {retQty > 0 ? `₹${retAmt.toFixed(2)}` : "—"}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}

                        {/* Financial Summary */}
                        <div className="card border-0 mb-3 bg-light" style={{ borderRadius: "12px" }}>
                          <div className="card-body p-3">
                            <h6 className="fw-bold mb-3 text-danger">Financial Summary</h6>
                            <div className="row g-2">
                              <div className="col-6">
                                <div className="d-flex justify-content-between border-bottom pb-2">
                                  <span className="text-muted small">Total Return Value</span>
                                  <span className="fw-bold">₹{fin.totalReturn.toFixed(2)}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between border-bottom pb-2">
                                  <span className="text-muted small">Customer Credit Balance</span>
                                  <span className="fw-bold text-info">₹{Math.max(0, parseFloat(returnOrder?.remaining || 0) - getOrderReturnedAmount(returnOrder?.order_id, returnOrder?.id)).toFixed(2)}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between border-bottom pb-2">
                                  <span className="text-muted small">Credit Adjusted</span>
                                  <span className="fw-bold text-warning">−₹{fin.creditAdjust.toFixed(2)}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between border-bottom pb-2">
                                  <span className="text-muted small">Refund Amount</span>
                                  <span className="fw-bold text-success">₹{fin.refundAmount.toFixed(2)}</span>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="d-flex justify-content-between">
                                  <span className="text-muted small">New Credit Balance</span>
                                  <span className="fw-bold text-primary">₹{fin.newCredit.toFixed(2)}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Refund Type Toggle */}
                        {fin.refundAmount > 0 && (
                          <div className="mb-3">
                            <label className="fw-semibold mb-2 d-block text-slate-700">How to handle ₹{fin.refundAmount.toFixed(2)} refund?</label>
                            <div className="d-flex gap-3">
                              <div
                                className={`flex-fill p-3 rounded border cursor-pointer ${returnRefundType === "bank" ? "border-danger bg-danger bg-opacity-10" : "bg-white"}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => setReturnRefundType("bank")}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <input type="radio" checked={returnRefundType === "bank"} onChange={() => setReturnRefundType("bank")} />
                                  <div>
                                    <div className="fw-bold small">Refund to Bank</div>
                                    <div className="text-muted" style={{ fontSize: "11px" }}>Cash paid back to customer now</div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`flex-fill p-3 rounded border cursor-pointer ${returnRefundType === "payable" ? "border-primary bg-primary bg-opacity-10" : "bg-white"}`}
                                style={{ cursor: "pointer" }}
                                onClick={() => setReturnRefundType("payable")}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <input type="radio" checked={returnRefundType === "payable"} onChange={() => setReturnRefundType("payable")} />
                                  <div>
                                    <div className="fw-bold small">Keep as Customer Credit</div>
                                    <div className="text-muted" style={{ fontSize: "11px" }}>Reduce on next sale or pay later</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Return Reason */}
                        <div className="mb-3">
                          <label className="fw-semibold mb-1 small text-slate-700">Return Reason <span className="text-muted">(optional)</span></label>
                          <textarea
                            className="form-control form-control-sm"
                            rows={2}
                            placeholder="e.g. Damaged product, Wrong item..."
                            value={returnReason}
                            onChange={(e) => setReturnReason(e.target.value)}
                            style={{ borderRadius: "8px" }}
                          />
                        </div>

                        <div className="text-muted small">
                          Return Invoice#: <strong>{returnInvoiceNo}</strong>
                        </div>
                      </div>
                    );
                  })()
                )}
              </div>

              {/* Footer */}
              <div className="modal-footer border-0 pt-0 px-4 pb-4">
                <button
                  type="button"
                  className="btn btn-secondary px-4 py-2 rounded-xl fw-semibold"
                  onClick={() => setShowReturnModal(false)}
                >
                  Cancel
                </button>
                {returnOrder && (
                  <button
                    type="button"
                    className="btn btn-danger px-4 py-2 rounded-xl fw-bold"
                    onClick={handleSubmitReturn}
                    disabled={calcReturnFinancials().totalReturn === 0}
                  >
                    Confirm Return — ₹{calcReturnFinancials().totalReturn.toFixed(2)}
                  </button>
                )}
              </div>

            </div>
          </div>
        </div>
      )}
      {showHeldSalesModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(15, 23, 42, 0.4)", backdropFilter: "blur(8px)", zIndex: 1060 }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "20px", overflow: "hidden" }}>
              
              {/* Header */}
              <div className="modal-header px-4 py-3 border-0" style={{ background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" }}>
                <h5 className="modal-title text-white fw-bold mb-0 d-flex align-items-center gap-2">
                  <i className="bi bi-clock-history"></i> Held Sales List
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowHeldSalesModal(false)}
                />
              </div>

              {/* Body */}
              <div className="modal-body p-4" style={{ maxHeight: "400px", overflowY: "auto" }}>
                {heldSales.length === 0 ? (
                  <div className="text-center text-slate-400 py-4">
                    <i className="bi bi-inbox fs-3 mb-2 d-block"></i>
                    No sales currently on hold
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    {heldSales.map((item) => (
                      <div
                        key={item.id}
                        className="p-3 border border-slate-100 rounded-xl d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer", transition: "background 0.2s", background: "#f8fafc" }}
                        onClick={() => handleResumeSale(item)}
                      >
                        <div className="text-start">
                          <div className="fw-bold text-slate-700">{item.customerName}</div>
                          <div className="text-xs text-slate-400 mt-0.5">
                            Hold Time: {item.time} &bull; {item.products.length} {item.products.length === 1 ? 'item' : 'items'}
                          </div>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="fw-bold text-slate-700 me-2" style={{ fontSize: "15px" }}>
                            ₹{parseFloat(item.totalAmount || 0).toFixed(2)}
                          </span>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm px-3 rounded-lg fw-bold"
                            onClick={() => handleResumeSale(item)}
                          >
                            Resume
                          </button>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm p-1 rounded-lg d-flex align-items-center justify-content-center"
                            style={{ width: "30px", height: "30px" }}
                            onClick={(e) => handleDeleteHeldSale(item.id, e)}
                          >
                            <i className="bi bi-trash fs-6"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="modal-footer border-0 px-4 pb-4 pt-0">
                <button
                  type="button"
                  className="btn btn-secondary w-100 py-2 rounded-xl fw-semibold"
                  onClick={() => setShowHeldSalesModal(false)}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ItemSales;
